import React from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { useQuery } from '@tanstack/react-query';


const fetchTags = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tags/list`);
    return response.data.payload.tags;
};

const TagsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const TagLink = styled.a`
    display: inline-block;
    padding: 4px 8px;
    margin: 2px;
    background-color: ${props => props.$isActive ? '#2c5530' : '#f0f0f0'};
    color: ${props => props.$isActive ? '#fff' : '#333'};
    text-decoration: none;
    border-radius: 4px;
    font-size: 0.9rem;
    
    &:hover {
        background-color: #2c5530;
        color: #fff;
        text-decoration: none;
    }
`;

const TagsDiv = styled.div`
    margin-top: 25px;
    margin-bottom: 25px;
    margin-left: 15px;
    & h6 {
        font-size: 1.3rem;
        color: #2a5934;
        font-weight: 700;
        font-family: "Roboto slab", serif;
    },
    & p {
        font-size: 0.8rem;
        background: #9c9;
        color: #2a5934;
        padding: 1rem;
        border-radius: 5px;
        font-family: "Poppins";
        font-weight: 700;
    }
`;


export const NewsItemSidebarTags = ({post}) => {

    const { data: tags = [] } = useQuery({
        queryKey: ['tags'],
        queryFn: fetchTags,
    });

    const isTagSelected = (tagId) => {
        return post.tags.some(postTag => postTag.id === tagId);
    };

    return (
        <TagsDiv>
            <h6>TAGS</h6>
            <p>You can filter the list of available news items by selecting a tag below.</p>
            <TagsContainer>
                {tags.map((tag) => (
                    <TagLink
                        href={`/news/list/tag/${tag.id}/${tag.name}`}
                        key={tag.id}
                        $isActive={isTagSelected(tag.id)}
                    >
                        {tag.name}
                    </TagLink>
                ))}
            </TagsContainer>
            
        </TagsDiv>
    )
}